<script setup lang="ts">
import { defineProps } from 'vue'
import { CheckIcon } from '@heroicons/vue/24/outline'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'

defineProps<{ params: { data: any; openModalEdit?: (d: any) => void; validateVariable?: (id: string) => void } }>()
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div v-if="params.openModalEdit && params.data.variableStatus !== 'SENT_TO_LUCCA'" class="w-fit">
      <ButtonDaisy text="Editer" @click="params.openModalEdit(params.data)" />
    </div>
    <div v-if="params.validateVariable && params.data.variableStatus === 'VALIDATION_IC'" class="w-10">
      <ButtonDaisy text="" :icon="CheckIcon" @click="params.validateVariable(params.data.id)" />
    </div>
  </div>
</template>
